import { Button, Dialog, DialogContent, DialogContentText, IconButton, Link, TextField, Typography } from '@mui/material';
import { Fragment, useState } from 'react';
import DocumentPicker from '../pages/Document/DocumentPicker';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
//export interface IValidationMessage {controlId: string, message: string}
import React from 'react';
import DeleteIcon from "@mui/icons-material/HighlightOff";
import ArticleIcon from "@mui/icons-material/Article";
import DocumentActions from '../actions/DocumentActions';
import { enumSharedMsgs } from '../helpers/common.constants';
import MyDialogYesNo from './MyDialogYesNo'; 

export default function MyDocumentPicker(args) {
  let hasError = false;
  let message = "";
  let Record = args.Record;
  let controlId = args.Id;
  let required = args.Required;
  let disabled = args.Disabled;
  let placeHolder = args.PlaceHolder;
  let folderId = args.FolderId;
  let type = "text";

  const [selectionOfFiles, setSelectionOfFiles] = useState([]);
  const [RecordDelete, setRecordDelete] = useState({});
  const [ModalParams, setModalParams] = useState({ ShowModal: false, OnModalClose: null, OnModalHasChanges: null, Title: "", });
  const [ModalDeleteParams, setModalDeleteParams] = useState({ ShowModal: false });



  //Proveri dali ima greska
  if (required === true) {
    let errorCollection = args.ValidationMessages ? args.ValidationMessages : [];
    if (errorCollection != null && errorCollection.length > 0) {
      let currentOption = errorCollection.find((x) => x.controlId === args.Id);
      if (currentOption != null) {
        hasError = true;
        message = currentOption.message;
      }
    }
  }

  //Vo zavisnot od Value i HasError se refreshira komponentata
  let value = Record ? Record[args.Id] : "";

  //Ke go selektira ID-to vo Drop Down so pomos na GetRecord
  React.useEffect(() => {
    //let currentValue : string = value.toString();
    if (value === undefined || value === null) {
      value = "";
    }

    if (value !== "") {
      let jsonOfSelectedFiles = JSON.parse(value);
      setSelectionOfFiles(jsonOfSelectedFiles);
    }
  }, [value]); //default

  const openModalDocumentPicker = () => { setModalParams({ ShowModal: true }); };

  function onModalCloseDocumentPicker(docArgs) {
    //iscklu go modal-ot i pokazi gi izmenite vo Grid-ot
    setModalParams({ ShowModal: false });

    if (docArgs.SelectedFiles) {
      setSelectionOfFiles(docArgs.SelectedFiles);

      //ke gi zeme samo najvaznite raboti: folderId, folderName, fileId,fileName, isFolder 
      //a se drugo ke iskluci Writers, Owners, parent, child, etc 
      let newReducedSelectedFiles = prepareDataForDB(docArgs.SelectedFiles);
      let payload = { target: { name: controlId, value: JSON.stringify(newReducedSelectedFiles) } };
      args.HandleChange(payload);
    }

  }


  function prepareDataForDB(selectionOfFiles) {
    //iscklu go modal-ot i pokazi gi izmenite vo Grid-ot
    let arrGooglesForDB = selectionOfFiles.map(({ folderId, folderName, fileId,fileName, isFolder }) => ({ folderId, folderName, fileId,fileName, isFolder}));
    return arrGooglesForDB;

  }



  const downloadFile = (fileName, fileId) => {
    async function fetchData() {
      let payload = "/" + fileId;
      let response = await new DocumentActions().DownloadFileAsync(payload);

      // create file link in browser's memory
      const href = URL.createObjectURL(response.data);

      // create "a" HTML element with href to file & click
      const link = document.createElement("a");
      link.href = href;
      link.setAttribute("download", fileName); //or any other extension
      document.body.appendChild(link);
      link.click();

      // clean up "a" element & remove ObjectURL
      document.body.removeChild(link);
      URL.revokeObjectURL(href);
    }
    fetchData();
  };

  const openGoogleDriveDialog = (row) => {
    let url = "https://drive.google.com/drive/u/2/folders/" + row.folderId;
    window.open(url, "_blank");
  };



  const handleModalOpenToDelete = (record) => { //Povikuva onDelete(record);
    setRecordDelete(record);
    setModalDeleteParams({ ShowModal: true }); //Otvori popup
  };


  const handleModalCloseToDelete = (doDelete) => {
    if (doDelete) {
      deleteSelectedFolderOrFile(RecordDelete);
    }
    setModalDeleteParams({ ShowModal: false }); //Otvori popup
  };

  const deleteSelectedFolderOrFile = (row) => {

    //proveri prvo dali go ima vo kolekcija togas izbrisi go 
    let newSelectedOfFiles = selectionOfFiles;
    if (row.isFolder) {
      newSelectedOfFiles = newSelectedOfFiles.filter(a => a.folderId !== row.folderId);
    }
    else {
      newSelectedOfFiles = newSelectedOfFiles.filter(a => a.fileId !== row.fileId);
    }

    setSelectionOfFiles(newSelectedOfFiles);

    //isprati vo RECORD informacija
     //ke gi zeme samo najvaznite raboti: folderId, folderName, fileId,fileName, isFolder 
      //a se drugo ke iskluci Writers, Owners, parent, child, etc 
      let newReducedSelectedFiles = prepareDataForDB(newSelectedOfFiles);
      let payload = { target: { name: controlId, value: JSON.stringify(newReducedSelectedFiles) } };
      args.HandleChange(payload);
  };


  const selectedFolderFileName = (row, showSeparator) => {
    if (row.isFolder)
      return (
        <React.Fragment>
          <Link
            tabIndex={-1}
            fontSize={13}
            component="button"
            underline="none"
            rel="noopener noreferrer"
            onClick={() => openGoogleDriveDialog(row)}
          >
            {row.folderName}
          </Link>

          <Link
            tabIndex={-1}
            onClick={() => handleModalOpenToDelete(row)}
            fontSize={13}
            component="button"
            underline="none"
            rel="noopener noreferrer"
            sx={{ pl: 1.2 }}
          >

            <DeleteIcon style={{ fontSize: 13 }} />
          </Link>
          {showSeparator ? ", " : ""}
        </React.Fragment>
      );
    else return (
      <React.Fragment>
        <Link
          tabIndex={-1}
          onClick={() => downloadFile(row.fileName, row.fileId)}
          component="button"
          underline="none"
          rel="noopener noreferrer"
        >
          <ArticleIcon sx={{ fontSize: 15 }} /> &nbsp;{row.fileName}
        </Link>

        <Link
          tabIndex={-1}
          fontSize={13}
          onClick={() => handleModalOpenToDelete(row)}
          component="button"
          underline="none"
          rel="noopener noreferrer"
          sx={{ pl: 1.2 }}


        >
          <DeleteIcon style={{ fontSize: 15 }} />
        </Link>
        {showSeparator ? ", " : ""}
      </React.Fragment>
    );
  };

  return (

    <Typography sx={{ pl: 0.6, pb: 0.5, fontSize: "0.8rem" }} color="text.secondary" align="left">
      {placeHolder}<br />
      {selectionOfFiles.length > 0 && selectionOfFiles.map((row, index) => (selectedFolderFileName(row, index !== selectionOfFiles.length - 1)))}
      {selectionOfFiles.length > 0 && <br />}

      <Button
        name="btnCancel"
        variant="contained"
        color="info"
        size="small"
        disabled={disabled}
        endIcon={<FolderOpenIcon />}
        onClick={() => openModalDocumentPicker()}
      >
        Select Documents
      </Button>
      {message != '' && <span style={{ fontSize: "0.8rem", color: "#d32f2f" }} ><br />{message}</span>}

      <Dialog open={ModalParams.ShowModal} onClose={ModalParams.OnModalClose} PaperProps={{ sx: { width: "100%", height: "100%" } }}>
        <DialogContent>
          <DialogContentText>
            <DocumentPicker InputFolderID={args.InputFolderID} OnModalClose={onModalCloseDocumentPicker} SelectedFiles={selectionOfFiles} />
          </DialogContentText>
        </DialogContent>
      </Dialog>

      <MyDialogYesNo IsOpen={ModalDeleteParams.ShowModal} Record={RecordDelete} HandleModalClose={handleModalCloseToDelete} Title={enumSharedMsgs.WariningMsg} Content={enumSharedMsgs.DeleteFileAreYouSure} />
    </Typography>

  );
};
